package org.mkui.component

import org.mkui.canvas.*

class InteractiveComponentListeners {
    val mouseListeners : MutableList<MouseListener> = ArrayList()
    val mouseMotionListeners: MutableList<MouseMotionListener> = ArrayList()
    val mouseWheelListeners: MutableList<MouseWheelListener> = ArrayList()
    val keyListeners: MutableList<KeyListener> = ArrayList()
    val contextMenuListeners: MutableList<ContextMenuListener> = ArrayList()

    fun addMouseListener(l: MouseListener) {
        mouseListeners.add(l)
    }

    fun addMouseMotionListener(l: MouseMotionListener) {
        mouseMotionListeners.add(l)
    }

    fun removeMouseListener(l: MouseListener) {
        mouseListeners.remove(l)
    }

    fun removeMouseMotionListener(l: MouseMotionListener) {
        mouseMotionListeners.remove(l)
    }
}